import {Component, Input, signal, WritableSignal} from '@angular/core';
import {DatePipe, KeyValuePipe} from "@angular/common";
import {NbDialogService, NbIconModule, NbPopoverModule, NbSpinnerModule} from "@nebular/theme";
import {Utils} from "../../../../shared/utils";
import {TeamsService} from "../../../../services/teams.service";
import {ScreenshotsGalleryComponent} from "../../../admin/games/screenshots-gallery/screenshots-gallery.component";
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-match-board',
  standalone: true,
  imports: [
    TranslateModule,
    KeyValuePipe,
    NbSpinnerModule,
    NbIconModule,
    NbPopoverModule
  ],
  templateUrl: './match-board.component.html',
  styleUrl: './match-board.component.scss'
})
export class MatchBoardComponent {
  preserveOrder = (a: any, b: any) => 0;
  @Input() matchesByWeek!: WritableSignal<any>;
  @Input() currentUserTeamIds = signal<string[]>([]);

  constructor(
    public utils: Utils,
    protected teamsService: TeamsService,
    private dialogService: NbDialogService,
    private datePipe: DatePipe
  ) {}

  getGames(games: any) {
    return games;
  }

  getMatches(matches: any) {
    return matches.data;
  }

  openScreenshotsGallery(match: any) {
    this.dialogService.open(ScreenshotsGalleryComponent, {
      dialogClass: 'popup',
      context: {
        match: match
      },
    });
  }

  formatDate(dateString: any, format: string) {
    const date = new Date(dateString);
    return this.datePipe.transform(date, format) || dateString;
  }

  protected readonly Object = Object;
}
